import { render } from "./PatientManagement.vue?vue&type=template&id=e0172f08&scoped=true"
import script from "./PatientManagement.vue?vue&type=script&lang=js"
export * from "./PatientManagement.vue?vue&type=script&lang=js"

import "./PatientManagement.vue?vue&type=style&index=0&id=e0172f08&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0172f08"]])

export default __exports__